var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.dialogWidth },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.onenter.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "resizable-card",
          class: { "no-select": _vm.resizing },
          style: { height: _vm.dialogHeight + "px" },
        },
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "headline" }, [
                _vm._v("Trader Config (" + _vm._s(this.rules.name) + ")"),
              ]),
              _c("v-spacer"),
              _c("r-authorize", {
                attrs: {
                  master: _vm.masterAccess,
                  locked: _vm.model.locked,
                  enabled: _vm.model.enabled,
                },
                on: {
                  "update:locked": function ($event) {
                    return _vm.$set(_vm.model, "locked", $event)
                  },
                  "update:enabled": function ($event) {
                    return _vm.$set(_vm.model, "enabled", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-col",
                { attrs: { cols: "4", sm: "2", md: "2" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.showPreview()
                        },
                      },
                    },
                    [_vm._v("View JSON")]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-3", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "12", sm: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          disabled: "",
                          label: "UID:",
                          "hide-details": "",
                          outlined: "",
                          dense: "",
                        },
                        model: {
                          value: _vm.model.uid,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "uid",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.uid",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Name:" },
                        model: {
                          value: _vm.model.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("r-ship-kind", {
                        attrs: { model: _vm.model.trader, label: "Trader:" },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "trader", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Quantity:" },
                        model: {
                          value: _vm.model.quantity,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "quantity", _vm._n($$v))
                          },
                          expression: "model.quantity",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Start time:", "hide-details": "" },
                        model: {
                          value: _vm.model.startTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "startTime", _vm._n($$v))
                          },
                          expression: "model.startTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Safe time:", "hide-details": "" },
                        model: {
                          value: _vm.model.safeTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "safeTime", _vm._n($$v))
                          },
                          expression: "model.safeTime",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Duration:", "hide-details": "" },
                        model: {
                          value: _vm.model.duration,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "duration", _vm._n($$v))
                          },
                          expression: "model.duration",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-expansion-panels",
                    [
                      _c("r-guard-panel", {
                        attrs: { model: _vm.model.guard },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "guard", $event)
                          },
                        },
                      }),
                      _c(
                        "v-expansion-panel",
                        [
                          _c("v-expansion-panel-header", {
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ open }) {
                                  return [
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-top": "5px",
                                            },
                                          },
                                          [_vm._v("Orders Config")]
                                        ),
                                        _c("v-spacer"),
                                        _c("v-fade-transition", [
                                          open
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    display: "inline-flex",
                                                  },
                                                },
                                                [
                                                  _c("v-divider", {
                                                    staticClass: "mx-1",
                                                    attrs: { vertical: "" },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c(
                                "v-row",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "3", sm: "3" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Count:",
                                          "hide-details": "",
                                        },
                                        model: {
                                          value: _vm.model.ordersCount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.model,
                                              "ordersCount",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "model.ordersCount",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: { cols: "12", md: "12", sm: "12" },
                                    },
                                    [
                                      _c("r-trader-order-table", {
                                        attrs: {
                                          items: _vm.model.ordersCustom,
                                          title: "Custom",
                                        },
                                        on: {
                                          "update:items": function ($event) {
                                            return _vm.$set(
                                              _vm.model,
                                              "ordersCustom",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-expansion-panel",
                        [
                          _c("v-expansion-panel-header", {
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ open }) {
                                  return [
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-top": "5px",
                                            },
                                          },
                                          [_vm._v("Offers Config")]
                                        ),
                                        _c("v-spacer"),
                                        _c("v-fade-transition", [
                                          open
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    display: "inline-flex",
                                                  },
                                                },
                                                [
                                                  _c("v-divider", {
                                                    staticClass: "mx-1",
                                                    attrs: { vertical: "" },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c(
                                "v-row",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "3", sm: "3" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Count:",
                                          "hide-details": "",
                                        },
                                        model: {
                                          value: _vm.model.offersCount,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.model,
                                              "offersCount",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "model.offersCount",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: { cols: "12", md: "12", sm: "12" },
                                    },
                                    [
                                      _c("r-trader-offer-rule-table", {
                                        attrs: {
                                          items: _vm.model.offersRules,
                                          title: "Rules",
                                        },
                                        on: {
                                          "update:items": function ($event) {
                                            return _vm.$set(
                                              _vm.model,
                                              "offersRules",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: { cols: "12", md: "12", sm: "12" },
                                    },
                                    [
                                      _c("r-trader-offer-table", {
                                        attrs: {
                                          items: _vm.model.offersRequired,
                                          title: "Custom",
                                        },
                                        on: {
                                          "update:items": function ($event) {
                                            return _vm.$set(
                                              _vm.model,
                                              "offersRequired",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("r-reward-panel", {
                        attrs: {
                          model: _vm.model.ordersReward,
                          title: "Orders Reward",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "ordersReward", $event)
                          },
                        },
                      }),
                      _c("r-reward-panel", {
                        attrs: {
                          model: _vm.model.offersReward,
                          title: "Offers Reward",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "offersReward", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              !_vm.lockedAssess || _vm.masterAccess
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: { click: _vm.save },
                    },
                    [_vm._v(" Save ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("div", {
            staticClass: "resize-handle",
            on: { mousedown: _vm.startResize },
          }),
          _c("r-preview-dialog", { ref: "preview-dialog" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }